const matchAllUrlsRegex = /(https?:\/\/[^\s)]+)/gi;

export default matchAllUrlsRegex;
